<template>
  <div id="Survey">
    <v-form v-if="!textMessage" ref="surveyForm">
      <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
      <v-container>
        <v-layout wrap class="pr-4 pl-4"> 
          <v-flex xs12 sm12 md12 class="button-container pr-0">
            <div class="text-xs-right" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" :to="session.role() === 'parent' ? '/dashboard': '/admin/surveys'">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Submit</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex wrap class="pr-4 ml-4 pf-text-default">
            <p>{{ topContent }}</p>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex class="xs12 sm6">
        <v-autocomplete
          :disabled="session.role() === 'parent'"
          prepend-icon="star"
          v-model="survey.account"
          @keyup.enter="searchFamilies($event)"
          id="recipientSearch"
          :items="contactList"
          label="Family"
          hide-no-data
          placeholder="Search by Name / Nickname / PPN"
          hint="Type atleast 3 characters to search"
          :rules="[rules.toRule]"
          item-text="text"
          item-value="value"
          @change="changeData($event)"
          class="pr-4 pl-4">
          <v-icon v-if="session.role() === 'admin'" slot="append" @click="searchFamilies($event)"> search </v-icon>
          </v-autocomplete>
        </v-flex>
        </v-layout>
        <v-layout wrap class="pb-4 pt-3">
            <v-flex xs12 sm6>
              <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="survey.explained_clearly" label="Was the profile process explained to you clearly ?" column>
                <v-radio label="Yes" color="success" value="Yes"></v-radio>
                <v-radio label="No" color="success" value="No"></v-radio>
                <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6>
              <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="survey.meeting_ontime" label="Did your meeting start on the communicated date and time ?" column>
                <v-radio label="Yes" color="success" value="Yes"></v-radio>
                <v-radio label="No" color="success" value="No"></v-radio>
                <v-radio label="No - but it was due to our conflict" color="success" value="No - but it was due to our conflict"></v-radio>
                <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6>
              <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="survey.helpful" label="Was the person that you worked with helpful in creating your profile ?" column>
                <v-radio label="Yes" color="success" value="Yes"></v-radio>
                <v-radio label="No" color="success" value="No"></v-radio>
                <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6>
              <v-radio-group class="pr-4 pl-5" v-model="survey.communicate_clearly" label="Did the person that worked with you on your profile communicate clearly ?" column>
                <v-radio label="Yes" color="success" value="Yes"></v-radio>
                <v-radio label="No" color="success" value="No"></v-radio>
                <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6>
              <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="survey.overall_timelines" label="Were overall timelines communicated to you ?" column>
                <v-radio label="Yes" color="success" value="Yes"></v-radio>
                <v-radio label="No" color="success" value="No"></v-radio>
                <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6>
              <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="survey.meet_timelines" label="Did we meet the timelines ?" column>
                <v-radio label="Yes" color="success" value="Yes"></v-radio>
                <v-radio label="No" color="success" value="No"></v-radio>
                <v-radio label="No, because of our delay" color="success" value="No, because of our delay"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6>
              <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="survey.rating" label="Overall satisfaction with profile creation process ?" column>
                <v-radio label="Wow it has been great !" color="success" value="5"></v-radio>
                <v-radio label="Very satisfied" color="success" value="4"></v-radio>
                <v-radio label="Satisfied" color="success" value="3"></v-radio>
                <v-radio label="Slightly satisfied" color="success" value="2"></v-radio>
                <v-radio label="Not satisfied" color="success" value="1"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="pr-4 pl-5 mt-4 v-label theme--light">Additional Feedback:</div>
            <v-textarea
            outline
            class="pr-4 pl-5 mt-3"
            label="Your feedback"
            no-resize
            height="175px"
            v-model="survey.additional_feedback"
            @click="selectedData=true"></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 v-if="survey.rating === '1' || survey.rating === '2'">
              <div class="pr-4 pl-5 mt-4 v-label theme--light">
                We apologize for not meeting your expectations. Your opinion is very valuable to us.
                Please let us know how we can improve the service or problems you ran into.
              </div>
            <v-textarea
            outline
            class="pr-4 pl-5 mt-3"
            no-resize
            height="175px"
            v-model="survey.satisfaction_feedback"
            @click="selectedData=true"></v-textarea>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="pr-4 pl-5 mt-4 v-label theme--light">What part of the process was the  easiest or most helpful ?</div>
            <v-textarea
            outline
            class="pr-4 pl-5 mt-3"
            label="Easiest or helpful"
            no-resize
            height="175px"
            v-model="survey.comment"
            @click="selectedData=true"></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 v-if="survey.rating === '1' || survey.rating === '2'">
              <v-radio-group class="pr-4 pl-5" v-model="isContact" label="Would you like someone to contact you ?" column>
                <v-radio label="Yes" color="success" value="Yes"></v-radio>
                <v-radio label="No" color="success" value="No"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6 v-if="(survey.rating === '1' || survey.rating === '2') && isContact === 'Yes'">
              <v-menu
                v-model="date.picker"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="FormattedDate"
                    :label="date.label"
                    hint="MM/DD/YYYY"
                    persistent-hint
                    readonly
                    clearable
                    prepend-icon="event"
                    @blur="survey.contact.date = parseDate(FormattedDate); selectedData = true"
                    v-on="on"
                    class="pr-4 pl-4"
                    @input="isFormDataChanged = true; selectedData = true"
                  ></v-text-field>
                </template>
                <v-date-picker :min="new Date().toISOString().substr(0, 10)" v-model="survey.contact.date" @input="date.picker = false"></v-date-picker>
              </v-menu>
              <v-menu
                  ref="menu"
                  v-model="time.picker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="time"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="survey.contact.time"
                      class="pr-4 pl-4"
                      :label="time.label"
                      prepend-icon="access_time"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-model="time.value"
                    full-width
                    @click:minute="time.picker = false"
                  ></v-time-picker>
                </v-menu>
                <v-text-field
                prepend-icon="star"
                v-mask="'(###) ###-####'"
                label="Phone Number" 
                v-model="survey.contact.phone"
                @input="selectedData=true"
                :rules="[rules.phoneRules]"
                class="pr-4 pl-4">
            </v-text-field>
            </v-flex>
        </v-layout>
        <v-layout class="pr-4 pl-4">
          <v-flex xs12 sm12 md12 class="pr-0">
            <div class="text-xs-right" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" :to="session.role() === 'parent' ? '/dashboard': '/admin/surveys'">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Submit</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-container v-else>
        <v-layout wrap>
          <v-flex wrap class="pr-4 ml-4 pf-text-default text-xs-center">
            <p id="message">{{ topContent }} </p>
          </v-flex>
        </v-layout>
    </v-container>
  </div>
</template>
<script>
/* global session store */
import { mapGetters } from 'vuex';
import { mask } from 'vue-the-mask';
import { getCollection, create } from '../../helpers/helpers';
import swal from 'sweetalert2';
export default {
  name: 'surveyList',
  directives: { mask },
  components: {

  },
  data: () => ({
    contactList: [],
    submittedAccounts: [],
    initializeFlag: true,
    textMessage: false,
    FormattedDate: null,
    isContact: '',
    survey: {
      account: '',
      explained_clearly: null,
      meeting_ontime: null,
      helpful: null,
      communicate_clearly: '',
      overall_timelines: null,
      meet_timelines: null,
      comment: '',
      rating: null,
      additional_feedback: '',
      satisfaction_feedback: '',
      contact: {
        date: null,
        time: null,
        phone: null
      }
    },
    date: {
      label: 'Date',
      value: null,
      picker: false
    },
    time: {
      label: 'Time',
      picker: false
    },
    familyList: [],
    query: {
      family: ''
    },
    required: [
      v => !!v || 'This option is required',
    ],
    rules: {
      toRule: (v) => !!v || 'Please select recipient',
      phoneRules: (v) => /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number',
    }, 
    selectedData: false,
    topContent: `Your opinion is very important to us. We would appreciate
                 if you could take a few moments and answer the following
                 questions to help us improve our service to you !`
  }),
  computed: {
    ...mapGetters(['Account']),
    Survey: {
      set (value) {
        store.commit('setSurvey', value);
      },
      get () {
        return store.state.Survey;
      }
    }
  },
  watch: {
    'time.value' (newVal, oldVal) {
      if (newVal !== oldVal) {
        let hr = Number(newVal.split(':')[0]);
        let mi = Number(newVal.split(':')[1]);
        if (mi < 10) {
          mi = `0${mi}`;
        }
        if (hr > 12) {
          hr = hr - 12;
          if (hr < 10) (hr = `0${hr}`);
        }
        this.survey.contact.time = Number(newVal.split(':')[0]) > 12 ? `${hr}:${mi}pm` : `${newVal}am`;
      }
    },
    survey: {
      handler: function (after, before) {
        this.selectedData = true;
        if (after.contact) {
          this.FormattedDate = this.formatDate((after.contact.date));
        }
      },
      deep: true
    },
    handler: function () {
      if (!this.initializeFlag) {
        this.selectedData = true;
      } else {
        this.initializeFlag = false;
      }
    },
    deep: true
  }, 
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {
    await this.initialize();
    if (session.role() === 'parent') {
      await this.loginUser();
    } else {
      this.initializeFlag = false;
    }
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
  },
  methods: {
    // @vuese
    // Used to fetch the survey list if not exists
    async initialize () {
      if (!this.Survey.length) {
        let { error, data } = await getCollection('Survey', true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setSurvey', data);
            this.getSubmittedFamilies();
          }
        }
      } else {
        this.getSubmittedFamilies();
      }
    },
    // @vuese
    // Used to fetch the family ids those who are already submitted the survey.
    getSubmittedFamilies () {
      if (this.Survey.length) {
        this.submittedAccounts = Array.from(this.Survey, survey => (survey.account ? survey.account.id : ''));
      }
    },
    async loginUser () {
      let obj = {
        text: this.Account.name,
        value: this.Account.id
      };
      this.contactList.push(obj);
      this.survey.account = await this.contactList[0].value;
      setTimeout(() => {
        this.changeData(this.Account.id);
      }, 10);
    },
    async searchFamilies (e) {
      this.familyList = [];
      this.contactList = [];
      this.query.family = e.target.value ? e.target.value : document.querySelector('input[id="recipientSearch"]').value;
      let profile_number = this.query.family;
      let profile_year = this.query.family;
      if ((this.query.family && this.query.family.length && this.query.family.length > 2)) {
        let where = { };
        if (this.query.family && this.query.family.length > 2) {
          if (!where.$or) {
            where.$or = [{
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            }, {
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }, {
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }];
          } else {
            where.$or.push({
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            });
            where.$or.push({
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
            where.$or.push({
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
          }
        }
        let populate = [{ 'path': 'human' }, 'contactInfo.country', 'contactInfo.state'];
        let { error, data } = await getCollection('Account', true, 0, populate, where);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            this.familyList = data;
            this.families();
          } else {
            this.families();
          }
        }
      }
    },
    // @vuese
    // Used to create the contact list from the family list
    async families () {
      this.familyList.forEach(item => {
        let obj = {};
        if (item.nickname.includes(document.querySelector('input[id="recipientSearch"]').value)) {
          obj = {
            text: item.nickname,
            value: item.id
          };
        } else {
          let text = '';
          if (item.ppn === document.querySelector('input[id="recipientSearch"]').value) {
            text = `${item.ppn} / ${item.name}`;
          } else {
            text = item.name;
          }
          obj = {
            text: text,
            value: item.id
          };
        }
        this.contactList.push(obj);
      });
    },
    async save () {
      if (this.$refs.surveyForm.validate()) {
        if (!this.survey.communicate_clearly) {
          delete this.survey.communicate_clearly;
        }
        if (!this.survey.contact.phone) {
          delete this.survey.contact;
        } else if (this.survey.contact) {
          if (!this.survey.contact.date) {
            delete this.survey.contact.date;
          }
          if (!this.survey.contact.time) {
            delete this.survey.contact.time;
          }
        }
        this.survey.rating = Number(this.survey.rating);
        this.selectedData = false;
        let { error, data } = await create('Survey', this.survey);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.Survey.unshift(data);
          if (session.role() === 'admin') {
            swal.fire({
              type: 'success',
              title: 'Survey submitted successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                this.$router.push({ path: '/admin/surveys' });
              }
            });
          } else {
            this.textMessage = true;
            this.topContent = 'Thank you for participating in our survey.';
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate (date) {
      if (!date) return '';
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      if (session.role() === 'parent') {
        this.$router.push({ path: '/dashboard' });
      } else {
        this.$router.push({ path: '/admin/surveys' });
      }
    },
    changeData (event) {
      if (session.role === 'admin') {
        this.selectedData = true;
        if (this.submittedAccounts.indexOf(event) > -1) {
          swal.fire({
            title: 'Already submmited for this parent!',
            text: 'Do you wish to submit the survey again?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
          }).then((result) => {
            if (result.dismiss) {
              this.survey.account = '';
            }
          });
        }
      } else {
        if (this.submittedAccounts.indexOf(event) > -1) {
          this.textMessage = true;
          this.topContent = 'You have already submitted the survey. Thank you for your feedback.';
        }
      }
    }
  }
};
</script>


<style scoped>
#Survey >>> .v-input__prepend-outer .v-icon.material-icons {
  font-size: 0.6rem;
  color: red !important;
}

#Survey >>> .v-input--is-readonly .v-input__prepend-outer .v-icon.material-icons {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.54) !important;
}

#Survey >>> .v-input__prepend-outer {
  margin-right: 0;
}
  </style>



// WEBPACK FOOTER //
// src/pages/Surveys/add.vue